const container = "_container_qnvru_18";
const input = "_input_qnvru_32";
const ui = "_ui_qnvru_42";
const styles = {
  container,
  input,
  ui
};
export {
  container,
  styles as default,
  input,
  ui
};
//# sourceMappingURL=Toggle.module.css.js.map
